import React, { useState } from 'react';

import { Grid, IconButton, InputAdornment, TextField, Typography } from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';

export default ({ onCriteriaChange = [] }) => {
  const [keyword, setKeyword] = useState('');

  const onSearchChange = (event) => {
    setKeyword(event.target.value);
  };

  const onSearchClick = () => {
    onCriteriaChange({ keyword });
  };

  const renderSearchInput = () => (
    <Grid container justify="flex-end">
      <TextField
        onChange={onSearchChange}
        onKeyUp={(evt) => {
          if (evt.key === 'Enter') {
            onSearchClick();
          }
        }}
        placeholder="Search"
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <IconButton onClick={onSearchClick}>
                <SearchIcon />
              </IconButton>
            </InputAdornment>
          ),
        }}
        type="text"
      />
    </Grid>
  );

  return (
    <Grid container alignItems="flex-end" justify="space-between">
      <Grid item xs={12} md={8}>
        <Typography variant="h4" align="left" className="page-header">
          Study Dashboard
        </Typography>
        <Typography variant="body2" align="left">
          Below you will find all of the orders you have placed and the current status for each
        </Typography>
      </Grid>

      <Grid item xs={12} md={4}>
        {renderSearchInput()}
      </Grid>
    </Grid>
  );
};
